import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import i18next from 'i18next';
import { toast } from 'react-toastify';
import App from './App';
import './i18n';
import './index.css';
import { store } from './redux/store';
import ErrorBoundary from 'components/error-boundary/error-boundary.component';
import { install } from 'resize-observer';
import { captureAttributionParams } from 'util/attributionParams';
import { getConfig } from 'util/config';

if (!window.ResizeObserver) install();

captureAttributionParams();

// Start (or claim the preload of) the per-domain config. Deliberately not
// awaited — blocking the first render on it would turn a hung request into an
// app that never paints.
getConfig();

ReactDOM.render(
  <Provider store={store}>
    <ErrorBoundary name="index">
      <App />
    </ErrorBoundary>
  </Provider>,
  document.getElementById('root'),
);

if (window.Cypress) {
  window.store = store;
  window.i18next = i18next;
  window.toast = toast;
}
